import { SummaryPanelController } from '../controller/SummaryPanelController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class SummaryPanelWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: SummaryPanelController,
    });
  }

  get incidentId(): string | null {
    return this.getAttribute('data-incident-id');
  }

  set incidentId(incidentId: string | null) {
    if (typeof incidentId === 'string') {
      this.setAttribute('data-incident-id', incidentId);
    }
  }

  get incidentScore(): number | null {
    const value = this.getAttribute('data-incident-score');
    return value ? parseInt(value, 10) : null;
  }
  set incidentScore(incidentScore: number | null) {
    if (typeof incidentScore === 'number') {
      this.setAttribute('data-incident-score', incidentScore.toString());
    }
  }

  get created(): string | null {
    return this.getAttribute('data-created');
  }
  set created(created: string | null) {
    if (typeof created === 'string') {
      this.setAttribute('data-created', created);
    }
  }

  get lastUpdated(): string | null {
    return this.getAttribute('data-last-updated');
  }
  set lastUpdated(lastUpdated: string | null) {
    if (typeof lastUpdated === 'string') {
      this.setAttribute('data-last-updated', lastUpdated);
    }
  }

  get attackTypes(): Array<string> {
    const value = this.getAttribute('data-attack-types');
    return value ? value.split(',') : [];
  }
  set attackTypes(attackTypes: Array<string>) {
    if (!Array.isArray(attackTypes) || !attackTypes.length) {
      this.setAttribute('data-attack-types', 'N/A');
    } else {
      this.setAttribute('data-attack-types', attackTypes.toString());
    }
  }

  get narrative(): any {
    const value = this.getAttribute('narrative');
    return value ? JSON.parse(value) : [];
  }

  set narrative(narrative: any) {
    if (typeof narrative !== 'object') {
      this.setAttribute('narrative', '[]');
    } else {
      this.setAttribute('narrative', JSON.stringify(narrative));
    }
  }

  get reasoning(): any {
    const value = this.getAttribute('reasoning');
    return value ? JSON.parse(value) : [];
  }

  set reasoning(reasoning: any) {
    if (typeof reasoning !== 'object') {
      this.setAttribute('reasoning', '[]');
    } else {
      this.setAttribute('reasoning', JSON.stringify(reasoning));
    }
  }

  get summaryMonitoring(): any {
    const value = this.getAttribute('summary-monitoring');
    return value ? JSON.parse(value) : [];
  }

  set summaryMonitoring(summaryMonitoring: any) {
    if (typeof summaryMonitoring !== 'object') {
      this.setAttribute('summary-monitoring', '[]');
    } else {
      this.setAttribute('summary-monitoring', JSON.stringify(summaryMonitoring));
    }
  }

  get incidentCompanyName(): string {
    return this.getAttribute('data-incident-company-name') ?? '';
  }

  set incidentCompanyName(companyName: string) {
    this.setAttribute('data-incident-company-name', companyName);
  }

  get incidentNumber(): number | null {
    const number = this.getAttribute('data-incident-number');
    return number ? parseInt(number, 10) : null;
  }

  set incidentNumber(incidentNumber: number | null) {
    this.setAttribute('data-incident-number', (incidentNumber ?? 0).toString());
  }
}
